import { render } from "./chart-c3.vue?vue&type=template&id=2f272e7a"
import script from "./chart-c3.vue?vue&type=script&lang=js"
export * from "./chart-c3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__